import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import './Signup.css';

function Signup() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
  
    try {
      const { data: existingUser } = await supabase
        .from('users')
        .select('user_email')
        .eq('email', email)
        .single();
  
      if (existingUser) {
        throw new Error('Email already registered');
      }
  
      const { data: newUser, error: dbError } = await supabase
        .from('users')
        .insert([
          {
            user_name: name,
            user_email: email,
            user_password: password,
          }
        ])
        .select()
        .single();
  
      if (dbError) throw dbError;

      localStorage.setItem('userSession', JSON.stringify({
        userId: newUser.user_id,
        email: newUser.user_email
      }));
  
      navigate(`/setup-goals/${newUser.user_id}`);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-box">
        <Link to="/" className="logo">
          <span>Stock</span><span className="logo-accent">Start</span>
        </Link>
        
        <div className="signup-header">
          <h2>Create Your Account</h2>
          <p>Start your smart investment journey today</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength="8"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="signup-submit-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Creating Account...' : 'Create Account'}
          </button>
        </form>

        <p className="login-link">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}

export default Signup;